export const parts = true;
export const dashpanels = true;
export const templates = true;
import * as views from './views';
export { views };
